<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>管理员管理</BreadcrumbItem>
        <BreadcrumbItem>管理员列表</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <div style="height:50px;">
          <div style="float:left">
            <Button type="primary" @click="addAdmin()">添加管理员</Button>
          </div>
          <div style="float:right;">
            <Button  icon="ios-search" style="float:right;margin-left:5px;" @click="getpage()">Search</Button>
            <Input v-model="search" style="float:right;width:250px;" />
          </div>
        </div>
        <div>
          <Table border ref="selection" :columns="columns7" :data="data6"></Table><br>
          <span style="align:center" >
            <span v-if = "$route.query.page == undefined ">
              <Page :total="10" :page-size="10" :current="1"  @on-change="getpage" />
            </span>
            <span v-else>
              <Page :total="10" :page-size="10" :current="parseInt($route.query.page)"  @on-change="getpage" />
            </span>
          </span>
        </div>

    </Content>
    <!-- 弹出框代码start -->
    <Modal
        v-model="modal1"
        @on-ok="ok"
        @on-cancel="cancel">
        <p class="modeldel">是否删除当前用户？</p>
    </Modal>
    <!-- 弹出框代码end -->
  </div>
</template>
<style scoped>
  .modeldel{
    font-size: 20px;
  }
</style>
<script>
import admin from '@/assets/js/views/admin/admin';

export default {
  ...admin,
};
</script>

